import { render } from "./LegoGameStats.vue?vue&type=template&id=446f8675&scoped=true"
import script from "./LegoGameStats.vue?vue&type=script&lang=js"
export * from "./LegoGameStats.vue?vue&type=script&lang=js"

import "./LegoGameStats.vue?vue&type=style&index=0&id=446f8675&lang=postcss&scoped=true"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-446f8675"]])

export default __exports__